export function sanitizePhoneNumber(str) {
  return str.replace(/[^\d+]/g, "");
}

export function formatPhoneNumber(str) {
  return str.replace(/(\+7)(\d{3})(\d{3})(\d{2})(\d{2})/, "$1 $2 $3 $4 $5");
}
